/**
 * Normalize API platform field to uppercase strings.
 */
export function normalizePlatforms(item) {
  const p = item.platform;
  if (p == null || (Array.isArray(p) && p.length === 0)) {
    return ['DSP'];
  }
  const arr = Array.isArray(p) ? p : [p];
  return arr.map((x) => String(x).toUpperCase());
}

/**
 * Split get_user_advertiser_details rows into DSP (UTC/JST), CTV (UTC-only), and GTV (UTC-only) buckets.
 * Rows may appear in DSP and CTV and/or GTV when platform includes more than one.
 */
export function classifyInvitedUserAdvertisersFromApi(selectedData) {
  const advertisersUtc = [];
  const advertisersNonUtc = [];
  const advertisersCtv = [];
  const advertisersGtv = [];
  const ctvSeen = new Set();
  const gtvSeen = new Set();

  for (const item of selectedData) {
    const plats = normalizePlatforms(item);
    const isCtv = plats.includes('CTV');
    const isGtv = plats.includes('GTV');
    const isDsp = plats.includes('DSP') || (!isCtv && !isGtv);

    const base = {
      id: item.advertiser_guid,
      name: item.advertiser_name,
      org_name: item.org_name,
      timezone: item.timezone,
      sfId: item.salesforce_account_id || ''
    };

    if (isDsp) {
      if (item.timezone === 'JST') {
        advertisersNonUtc.push({ ...base });
      } else if (item.timezone === 'UTC') {
        advertisersUtc.push({ ...base });
      }
    }

    if (isCtv && item.timezone !== 'JST') {
      const key = item.advertiser_guid || item.advertiser_name;
      if (key && !ctvSeen.has(key)) {
        ctvSeen.add(key);
        advertisersCtv.push({ ...base, timezone: 'UTC' });
      }
    }

    if (isGtv && item.timezone !== 'JST') {
      const key = item.advertiser_guid || item.advertiser_name;
      if (key && !gtvSeen.has(key)) {
        gtvSeen.add(key);
        advertisersGtv.push({ ...base, timezone: 'UTC' });
      }
    }
  }

  return {
    advertisers_utc: advertisersUtc,
    advertisers_non_utc: advertisersNonUtc,
    advertisers_ctv: advertisersCtv,
    advertisers_gtv: advertisersGtv
  };
}
